
import AppCompanyInfoUserModal from "@/components/company/CompanyInfoUserModal.vue";
import { Company } from "@/models/company";
import { User } from "@/models/user";
import { IDataTableColumn } from "winfakt-vue-components/src/classes";
import AppCompanyInfoWrapper from "./CompanyInfoWrapper.vue";
import Vue from "vue";
import AppLoginAsUserButton from "@/components/LoginAsUserButton.vue";

export default Vue.extend({
	data() {
		return {
			editModal: false,

			orderColumn: "id",
			orderDirection: false,
			selected: [] as User[],
			toShowUser: new User()
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		}
	},
	computed: {
		orderedUsers():User[] {
			let result = [...this.users].sort((a:any, b:any) => {
				if (typeof(a[this.orderColumn]) == "string") {
					if (this.orderDirection) {
						return (a[this.orderColumn] as string).localeCompare(b[this.orderColumn]);
					}
					return (b[this.orderColumn] as string).localeCompare(a[this.orderColumn]);
				}
				if (this.orderDirection) {
					return (a[this.orderColumn] as number) - (b[this.orderColumn] as number);
				}
				return(b[this.orderColumn] as number) - (a[this.orderColumn] as number);
			});
			return result;
		},
		users():User[] {
			return this.value.users;
		},
		notAllowedToView():boolean {
			if (this.selected.length == 1) {
				return false;
			}
			return true;
		},
		showUserInfoToolTip():string {
			return "Toon gebruikers info";
		},
		loginAsUserToolTip():string{
			return "Aanmelden als gebruiker";
		},
		createTicketTooltip():string{
			return "Ticket aanmaken";
		},
		columns():IDataTableColumn[]{
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Activated",
					property: "activated",
					width: "50px"
				},
				{
					name: "Username",
					property: "username",
					width: "200px"
				},
				{
					name: "Email",
					property: "email",
					width: "200px"
				},
				{
					name: "",
					property: "isOwner",
					width: "200px",
					print(value:boolean):string {
						if (value) {
							return "Owner";
						}
						return "";
					}
				}
			];
		}
	},
	methods: {
		onOrder(event:any) {
			this.orderColumn = event.order;
			this.orderDirection = event.ascending;
		},
		showUserInfo(user?:User) {
			let u = user;
			if (!u){
				u = this.selected[0];
			}
			if (!u) return;
			this.editModal = true;
			this.toShowUser = this.selected[0];
		},
		createTicket(){
			if (!this.selected[0]) return;
			this.$router.push(`/ticket/new?userId=${this.selected[0].id}&companyId=${this.selected[0].companyId}`);
		}
	},
	components: {
		AppCompanyInfoUserModal,
		AppCompanyInfoWrapper,
		AppLoginAsUserButton
	}
});
